import { modalActions } from '@opengov/component-library-classic/module/modals';

import { basicCalculationActions } from '../application/common/basicCalculation/state';
import { conditionalActions } from '../application/common/createConditional/state';
import { reportConfigurationActions } from '../application/common/reportConfiguration/state';
import { reportTemplateActions } from '../application/common/reportTemplate';

export const actionsToTrack = [
  reportConfigurationActions.setVisualizationQueryShowColumnName,
  reportConfigurationActions.setVisualizationQueryCategorizedByColumn,
  reportConfigurationActions.setCategorizedByColumnAndResetGroupByColumns,
  reportConfigurationActions.setVisualizationQueryOrganizedByColumn,
  reportConfigurationActions.setVisualizationChartType,
  reportConfigurationActions.updateDetailTableQueryGroupByColumns,
  reportConfigurationActions.setColumnSort,
  reportConfigurationActions.clearColumnSort,
  reportConfigurationActions.setColumnFilters,
  reportConfigurationActions.clearColumnFilter,
  // create basic calculation flow:
  basicCalculationActions.updateValue1,
  basicCalculationActions.updateValue1CustomValue,
  basicCalculationActions.updateValue2,
  basicCalculationActions.updateValue2CustomValue,
  basicCalculationActions.updateOperator,
  reportConfigurationActions.addBasicCalculatedColumnToDetailTable,
  // create conditional flow:
  conditionalActions.updateSelectedColumnType,
  conditionalActions.updateIfValue,
  conditionalActions.updateCurrentConditionOperator,
  conditionalActions.updateCurrentConditionMatchValue,
  conditionalActions.updateCurrentConditionLowerBound,
  conditionalActions.updateCurrentConditionUpperBound,
  conditionalActions.updateCurrentConditionCustomValue,
  conditionalActions.updateCurrentConditionReturnedValue,
  conditionalActions.updateElseResult,
  conditionalActions.addCondition,
  reportConfigurationActions.addConditionalColumnToDetailTable,
  // modal actions -- track which modals were used/reset
  modalActions.setModalComponentType,
  modalActions.resetModalState,
  // standard reports/report templates
  reportTemplateActions.loadReportTemplatesRequest,
  reportTemplateActions.loadReportTemplatesSuccess,
  reportTemplateActions.loadReportTemplatesFailure,
  reportTemplateActions.setCurrentTemplate,
  reportTemplateActions.setCurrentLens
].map((action) => action.actionType);
